module.exports = __webpack_public_path__ + "media/CD.663d43bc.mp3";